import { Icon } from '@iconify/react'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import LogoDark from '../assets/images/icon.png'
import { useAuth } from '../hooks/useAuth'
import {
	Brand,
	LinkItem,
	NavGroup,
	SideRoot,
} from '../styles/SidebarStyle'
import SignOutModal from './SignOutModal'


const links = [
	{ to: '/overview', label: 'Overview', icon: 'solar:widget-5-outline', id: 'overview' },
	{ to: '/transactions', label: 'Transactions', icon: 'solar:transfer-horizontal-linear', id: 'transactions' },
	// { to: '/pending-giftcard', label: 'Pending Giftcard', icon: 'solar:card-linear', id: 'pending_giftcard' },
	{ to: '/users', label: 'User Management', icon: 'solar:user-circle-linear', id: 'user_management' },
	{ to: '/assets', label: 'Asset Management', icon: 'solar:wallet-money-linear', id: 'asset_management' },
	{ to: '/rates', label: 'Rates & Fees', icon: 'solar:tag-price-linear', id: 'rates_fees' },
	{ to: '/notifications', label: 'Notification', icon: 'solar:bell-linear', id: 'notifications' },
	{ to: '/settings', label: 'Settings', icon: 'solar:settings-linear', id: 'settings' },
]

export function Sidebar({ active }: { active?: string }): React.JSX.Element {
	const [showModal, setShowModal] = useState(false)
	const { logout } = useAuth()
	const navigate = useNavigate()

	const handleLogout = (e: React.MouseEvent) => {
		e.preventDefault()
		setShowModal(true)
	}

	const confirmLogout = () => {
		logout()
		setShowModal(false)
		navigate('/login', { replace: true })
	}

	return (
		<SideRoot>
			<Brand>
				<img src={LogoDark} alt='Ade Mart' />
			</Brand>

			<NavGroup>
				{links.map(({ to, label, icon, id }) => (
					<LinkItem key={to} to={to} end className={active === id ? 'active' : ''}>
						<Icon icon={icon} width={16} />
						<span>{label}</span>
					</LinkItem>
				))}
			</NavGroup>

			<LinkItem to='/login' onClick={handleLogout} className='mt-auto' end>
				<Icon icon='solar:logout-2-outline' width={16} />
				<span>Sign Out</span>
			</LinkItem>

			<SignOutModal open={showModal} onClose={() => setShowModal(false)} onConfirm={confirmLogout} />
		</SideRoot>
	)
}
